import { useParams, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageMeta from "@/components/PageMeta";
import AgencyLanding from "@/components/AgencyLanding";
import EnterpriseLanding from "@/components/EnterpriseLanding";
import { ServiceJsonLd } from "@/components/JsonLd";

const SolutionPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const { i18n } = useTranslation();
  const isDe = i18n.language?.startsWith("de");

  if (slug !== "agencies" && slug !== "enterprises") {
    return <Navigate to="/" replace />;
  }

  const meta =
    slug === "agencies"
      ? {
          title: isDe
            ? "Für Agenturen — autonome Delivery-Systeme | Raw Response Labs"
            : "For Agencies — autonomous delivery systems | Raw Response Labs",
          description: isDe
            ? "Wir bauen die Loops, die Ihre Agentur bisher manuell fährt — White-Label, in Ihrer Cloud, zum Festpreis in 90 Tagen."
            : "We build the loops your agency runs by hand today — white-label, in your cloud, fixed price in 90 days.",
          serviceName: isDe ? "Agentische Systeme für Agenturen" : "Agentic systems for agencies",
        }
      : {
          title: isDe
            ? "Für Enterprises — autonome Ops-Systeme | Raw Response Labs"
            : "For Enterprises — autonomous ops systems | Raw Response Labs",
          description: isDe
            ? "Ein wiederkehrender Prozess läuft als autonomes System — in Ihrer Cloud, mit Freigabestellen, in 90 Tagen live. Zum Festpreis."
            : "One recurring process runs as an autonomous system — in your cloud, with approval gates, live in 90 days. At a fixed price.",
          serviceName: isDe ? "Agentische Systeme für Enterprises" : "Agentic systems for enterprises",
        };

  return (
    <div className="min-h-screen bg-background">
      <PageMeta title={meta.title} description={meta.description} />
      <ServiceJsonLd name={meta.serviceName} description={meta.description} slug={slug} />
      <Navbar />
      <main>{slug === "agencies" ? <AgencyLanding /> : <EnterpriseLanding />}</main>
      <Footer />
    </div>
  );
};

export default SolutionPage;
